import styled from 'styled-components';

export const LogoSectionWrapper = styled.div`
  margin-top: 90px;
  min-height: 800px;

  @media (max-width: 800px) {
    min-height: 350px;
  }
`

export const CarouselImageWrapper = styled.div`
  height: inherit;
`

export const CarouselImage = styled.img`
  height: 100%;
  width: 100%; 
  object-fit: cover;
  padding: 35px;

  @media (max-width: 800px) {
    height: 350px;
    object-fit: contain;
    padding: 0;
  }
`